<div class="form form-filters" *ngIf="searchPreferences$ | async as searchPreferences">
  <ion-list>
    <ion-item (click)="openPickServiceModal( searchPreferences )" class="ion-no-padding clickable" mode="md">
      <ion-label position="stacked" mode="md">Storitev</ion-label>
      <!--<ion-input [ngModel]="searchPreferences.normalizedService?.name || 'Vse storitve'" readonly type="text" tabindex="10"></ion-input>-->
      <span class="fake-input-value">{{ searchPreferences.normalizedService?.name || 'Vse storitve' }}</span>
      <ion-icon  class="close" *ngIf="!!searchPreferences.normalizedService" (click)="resetNormalizedService($event)" name="close"></ion-icon>
    </ion-item>

    <ion-item (click)="openPickPlaceModal( searchPreferences )" class="--border ion-no-padding clickable" mode="md">
      <ion-label position="stacked" mode="md">Lokacija</ion-label>
      <!--ion-input [ngModel]="searchPreferences.place?.name || 'Vse lokacije'" readonly tabindex="11" type="text"></ion-input-->
      <span class="fake-input-value">{{ searchPreferences.place?.name || 'Vse lokacije' }}</span>
      <ion-icon class="close" *ngIf="!!searchPreferences.place" (click)="resetPlace($event)" name="close"></ion-icon>
    </ion-item>

    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-item style="padding-right:12px" (click)="openPickDateModal( searchPreferences )" class="ion-no-padding clickable" mode="md">
            <ion-label position="stacked" mode="md">Datum obiska</ion-label>
            <!--ion-input [ngModel]="searchPreferences.datePeriod?.toDisplayString() || 'Kadarkoli'" readonly tabindex="11" type="text"></ion-input-->
            <span class="fake-input-value">{{ searchPreferences.datePeriod?.toDisplayString() || 'Kadarkoli' }}</span>
            <ion-icon class="close" *ngIf="!!searchPreferences.datePeriod" (click)="resetDate($event)" name="close"></ion-icon>
          </ion-item>
        </ion-col>
        <ion-col>
          <ion-item style="padding-left:12px" (click)="openPickHoursModal( searchPreferences )" class="ion-no-padding clickable" mode="md">
            <ion-label position="stacked" mode="md">Ura obiska</ion-label>
            <!--ion-input [ngModel]="searchPreferences.hoursPeriod?.toDisplayString() || 'Vseeno'" readonly tabindex="11" type="text"></ion-input-->
            <span class="fake-input-value">{{ searchPreferences.hoursPeriod?.toDisplayString() || 'Vseeno' }}</span>
            <ion-icon class="close" *ngIf="!!searchPreferences.hoursPeriod" (click)="resetHours($event)" name="close"></ion-icon>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>

  </ion-list>
  <ion-button (click)="searchShopsByPreferences()" expand="full" tabindex="12" class="form__submit btn--large">POIŠČI TERMIN</ion-button>
</div>

<!--<ion-grid style="background-color: gray;" *ngIf="searchPreferences$ | async as searchPreferences">
  <ion-row>
    <ion-col>
      <ion-item (click)="openPickServiceModal( searchPreferences )">
        <ion-label>{{ searchPreferences.normalizedService?.name || 'Izberi storitev' }}</ion-label>
        <ion-icon *ngIf="!!searchPreferences.normalizedService" (click)="resetNormalizedService($event)" name="close"></ion-icon>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col>
      <ion-item (click)="openPickPlaceModal( searchPreferences )">
         <ion-label>{{ searchPreferences.place?.name || 'Izberi lokacijo' }}</ion-label>
         <ion-icon *ngIf="!!searchPreferences.place" (click)="resetPlace($event)" name="close"></ion-icon>
      </ion-item>
    </ion-col>
  </ion-row>


  <ion-row>
    <ion-col>
      <ion-item (click)="openPickDateModal( searchPreferences )">
         <ion-label>{{ searchPreferences.datePeriod?.toDisplayString() || 'Datum' }}</ion-label>
         <ion-icon *ngIf="!!searchPreferences.datePeriod" (click)="resetDate($event)" name="close"></ion-icon>
      </ion-item>
    </ion-col>

     <ion-col>
      <ion-item (click)="openPickHoursModal( searchPreferences )">
         <ion-label>{{ searchPreferences.hoursPeriod?.toDisplayString() || 'Ura' }}</ion-label>
         <ion-icon *ngIf="!!searchPreferences.hoursPeriod" (click)="resetHours($event)" name="close"></ion-icon>
      </ion-item>
    </ion-col>
  </ion-row>

   <ion-row>
    <ion-col>
      <ion-button (click)="searchShopsByPreferences()" expand="block">Poišči termin</ion-button>
    </ion-col>
  </ion-row>


</ion-grid>-->